import {
  GET_PRODUCT_SLIP_LIST_RESPONSE,
  UPDATE_PRODUCT_SLIP_STATUS_BY_PRODUCT_SLIP_ID_RESPONSE,
} from "./actionTypes";

import produce from "immer";

export const initialState = {
  productSlipApiResponse: null,
  productSlipData: [],
};

const productSlip = (state = initialState, action) =>
  produce(state, (draft) => {
    let response;
    switch (action.type) {
      case GET_PRODUCT_SLIP_LIST_RESPONSE:
        response = action.payload.apiResponse;
        if (response.isSuccessResponse) {
          draft.productSlipData = response.responseData;
        } else {
          draft.productSlipData = [];
        }
        break;

      case UPDATE_PRODUCT_SLIP_STATUS_BY_PRODUCT_SLIP_ID_RESPONSE:
        draft.productSlipApiResponse = action.payload.apiResponse;
        break;

      default:
        state = { ...state };
        break;
    }
  });

export default productSlip;
